import { useEffect, useRef, useState } from 'react'
import flatpickr from 'flatpickr'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

// #1079 日付入力(検索フィルタ / 案件フォーム共用)。flatpickr のカレンダーで選び、
// 送信値は hidden input に ISO(YYYY-MM-DD) で入れて既存のRailsフォームに任せる。
// Mantine の DateInput はこの環境でポップオーバーが開かないため使わない(see memory: mantine_v9_broken_components)。
export default function DateFilterInput({ name, value: initialValue, placeholder = '参画開始日', clearable = true, minDate, maxDate }) {
  const [value, setValue] = useState(initialValue || '')
  const inputRef = useRef(null)
  const fpRef = useRef(null)

  useEffect(() => {
    if (!inputRef.current) return undefined
    fpRef.current = flatpickr(inputRef.current, {
      locale: Japanese,
      dateFormat: 'Y-m-d',
      altInput: true,
      altFormat: 'Y年n月j日',
      allowInput: false,
      disableMobile: false,
      monthSelectorType: 'dropdown',
      defaultDate: initialValue || null,
      minDate: minDate || undefined,
      maxDate: maxDate || undefined,
      onChange: (_dates, dateStr) => setValue(dateStr),
    })
    if (fpRef.current.altInput) {
      fpRef.current.altInput.placeholder = placeholder
      fpRef.current.altInput.classList.add('biz-datepicker', 'biz-datepicker--filter')
    }
    return () => fpRef.current && fpRef.current.destroy()
    // 初期化は一度だけ(propsは初回描画時の値で固定)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const clear = () => {
    fpRef.current && fpRef.current.clear()
    setValue('')
  }

  return (
    <div className="biz-datepicker-wrap">
      <input type="hidden" name={name} value={value} />
      <input ref={inputRef} type="text" aria-label={placeholder} />
      {clearable && value && (
        <button type="button" onClick={clear} aria-label="クリア" className="biz-datepicker-clear">
          ×
        </button>
      )}
    </div>
  )
}
